import { Col, Container, Row } from "react-bootstrap";
import PageHeader from "../../components/pageHeader";
import {
  Button,
  Card,
  ConfigProvider,
  Dropdown,
  MenuProps,
  message,
  Select,
} from "antd";
import { IoIosArrowDropdown } from "react-icons/io";
import { useEffect, useState } from "react";
import "./styles.scss";
import AssetFilter from "./components/assetFilter";
import ReplacementModal from "./components/replacementModal";
import { GET } from "../../../utils/apiCall";
import API from "../../../config/api";

const SearchAnalyticsScreen = () => {
  const [kindValue, setKindValue] = useState<string>();
  const [categoryValue, setCategoryValue] = useState<string>();
  const [supplierValue, setSupplierValue] = useState<string>();
  const [searchValue, setSearchValue] = useState<string>();
  const [typeValue, setTypeValue] = useState<string>("");
  const [choose, setChoose] = useState<string>("");
  const [replaceSensorModal, setReplaceSensorModal] = useState<boolean>(false);
  const [data, setData] = useState([]);
  const [kind, setKind] = useState([]);
  const [category, setCategory] = useState<any>([]);
  const [supplier, setSupplier] = useState([]);
  const [sensortype, setSensorType] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const[meta,setMeta] = useState()
  const [page,setPage] = useState<number>(1)
  const pagesize = 10

  useEffect(() => {
    getData();
    getKind();
    getCategory();
    getSupplier();
    getSensorType();
  }, [kindValue, categoryValue, supplierValue, searchValue, typeValue,page]);
  const getData = async () => {
    try {
      setLoading(true);
      let url = `${API.SEARCH_ANALYTIC_URL + API.GET_SEARCH_TWIN}?`;

      if (kindValue) {
        url += `filters[kind][$eq]=${kindValue}&`;
      }
      if (categoryValue) {
        url += `filters[category][$eq]=${categoryValue}&`;
      }
      if (supplierValue) {
        url += `filters[supplier][$eq]=${supplierValue}&`;
      }
      if (typeValue) {
        url += `filters\[child\][name][$contains]=${typeValue}&filters\[child\][kind][$eq]=${4}&filters\[child\][category][$eq]=${4}&`;
      }
      if (searchValue) {
        url += `filters[id_short][$containsi]=${searchValue}&`;
      }
      url += `populate[0]=kind&populate[1]=category&populate[2]=supplier&populate[3]=derived_from&populate[4]=child.kind&populate[5]=child.category&populate[6]=child.supplier&populate[7]=child.derived_from&pagination[page]=${page}&pagination[pageSize]=${pagesize}`;
      url = url.endsWith("&") ? url.slice(0, -1) : url;

      const response: any = await GET(url);

      if (response?.data?.length) {
        setData(response.data);
        setMeta(response?.meta)
      } else {
        message.error("No data found");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getKind = async () => {
    try {
      const response: any = await GET(
        `${API.SEARCH_ANALYTIC_URL + API.GET_KIND}`
      );
      if (response?.data?.length) {
        console.log("this", response?.data);
        const convertedData = convertData(response?.data);
        setKind(convertedData);
      } else {
        setKind([]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getSupplier = async () => {
    try {
      const response: any = await GET(
        API.SEARCH_ANALYTIC_URL + API.GET_SUPPLIER
      );
      if (response?.data?.length) {
        const convertedData = convertData(response?.data);
        setSupplier(convertedData);
      } else {
        setSupplier([]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getCategory = async () => {
    try {
      const response: any = await GET(
        API.SEARCH_ANALYTIC_URL + API.GET_CATEGORY
      );
      if (response?.data?.length) {
        const convertedData = convertData(response?.data);
        setCategory(convertedData);
      } else {
        setCategory([]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getSensorType = async () => {
    try {
      const response: any = await GET(
        `${
          API.SEARCH_ANALYTIC_URL + API.GET_SEARCH_TWIN
        }?filters[kind][$eq]=${4}&filters[category][$eq]=${4}`
      );
      if (response?.data?.length) {
        console.log("=========>", response?.data);
        const convertedData = convertDataType(response?.data);
        setSensorType(convertedData);
      } else {
        setSensorType([]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const convertData = (data: any) => {
    const array: any = [];
    data?.map((item: any) => {
      array.push({ label: item?.name, value: item?.id });
    });
    return array;
  };
  const convertDataType = (data: any) => {
    const array: any[] = [];
    const uniqueValues = new Set();
  
    data?.forEach((item: any) => {
      const label = item?.name;
      if (!uniqueValues.has(label)) { 
        array.push({ label, value: label });
        uniqueValues.add(label); 
      }
    });
  
    return array;
  };
  // const items = [
  //   {
  //     label: "Option 1",
  //     key: "1",
  //     onClick: () => setValue("Option 1"),
  //   },
  //   {
  //     label: "Option 2",
  //     key: "2",
  //     onClick: () => setValue("Option 2"),
  //   },
  //   {
  //     label: "Option 3",
  //     key: "3",
  //     onClick: () => setValue("Option 3"),
  //   },
  // ];
  // const setValue = (value: string) => {
  //   const type = choose;
  //   console.log("chose :", type, "value : ", value);
  //   switch (type) {
  //     case "kind":
  //       setKindValue(value);
  //       break;
  //     case "category":
  //       setCategoryValue(value);
  //       break;
  //     case "supplier":
  //       setSupplierValue(value);
  //       break;
  //     case "type":
  //       setTypeValue(value);
  //       break;
  //   }
  // };
  const replaceSensor = () => {
    console.log("here");
    setReplaceSensorModal(true);
  };
  const onChangeKind = (value: string) => {
    setKindValue(value);
  };
  const onChangeCategory = (value: string) => {
    setCategoryValue(value);
  };
  const onChangeSupplier = (value: string) => {
    setSupplierValue(value);
  };
  const onChangeSensorType = (value: string) => {
    console.log("this is hte value", value);
    setTypeValue(value);
  };
  const changePage = (page:any,pagesize:any)=>{
    setPage(page)
  }
  return (
    <main>
      <Container fluid>
        <PageHeader
          title={` Search Analytics`}
          breadcum={"Dashboard / Applications / Analytics"}
        ></PageHeader>
        <Card className="graph-view-container mb-4">
          <Row>
            <Col md={3}>
              <div className="d-flex flex-column">
                <text className="anlytics-text1 mb-2">Kind</text>
                <ConfigProvider
                  theme={{ token: { colorBgContainer: "#F3F3F3" } }}
                >
                  <Select
                    showSearch
                    placeholder="Select Kind"
                    optionFilterProp="label"
                    onChange={onChangeKind}
                    // onSearch={onSearch}
                    options={kind}
                    suffixIcon={
                      <IoIosArrowDropdown
                        style={{
                          color: "#087EA4",
                          width: 18,
                          height: 18,
                          border: 1.3,
                        }}
                      />
                    }
                    allowClear
                  />
                </ConfigProvider>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column">
                <text className="anlytics-text1 mb-2">Category</text>
                <ConfigProvider
                  theme={{ token: { colorBgContainer: "#F3F3F3" } }}
                >
                  <Select
                    showSearch
                    placeholder="Select Category"
                    optionFilterProp="label"
                    onChange={onChangeCategory}
                    // onSearch={onSearch}
                    options={category}
                    suffixIcon={
                      <IoIosArrowDropdown
                        style={{
                          color: "#087EA4",
                          width: 18,
                          height: 18,
                          border: 1.3,
                        }}
                      />
                    }
                    allowClear
                  />
                </ConfigProvider>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column">
                <text className="anlytics-text1 mb-2">Supplier</text>
                <ConfigProvider
                  theme={{ token: { colorBgContainer: "#F3F3F3" } }}
                >
                  <Select
                    showSearch
                    placeholder="Select Supplier"
                    optionFilterProp="label"
                    onChange={onChangeSupplier}
                    // onSearch={onSearch}
                    options={supplier}
                    suffixIcon={
                      <IoIosArrowDropdown
                        style={{
                          color: "#087EA4",
                          width: 18,
                          height: 18,
                          border: 1.3,
                        }}
                      />
                    }
                    allowClear
                  />
                </ConfigProvider>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex flex-column">
                <text className="anlytics-text1 mb-2">Has Sensor Type</text>
                <ConfigProvider
                  theme={{ token: { colorBgContainer: "#F3F3F3" } }}
                >
                  <Select
                    showSearch
                    placeholder="Select Sensor Type"
                    optionFilterProp="label"
                    onChange={onChangeSensorType}
                    // onSearch={onSearch}
                    options={sensortype}
                    suffixIcon={
                      <IoIosArrowDropdown
                        style={{
                          color: "#087EA4",
                          width: 18,
                          height: 18,
                          border: 1.3,
                        }}
                      />
                    }
                    allowClear
                  />
                </ConfigProvider>
              </div>
            </Col>
          </Row>
        </Card>
        <AssetFilter
          data={data}
          loading={loading}
          meta={meta}
          search={(value: any) => {
            setSearchValue(value);
          }}
          replacesensor={() => {
            replaceSensor();
          }}
          onPageChange={(page:any,pagesize:any)=>{
            changePage(page,pagesize)
          }}
        />
      </Container>
      {replaceSensorModal && (
        <ReplacementModal
          open={replaceSensorModal}
          close={() => setReplaceSensorModal(false)}
        />
      )}
    </main>
  );
};

export default SearchAnalyticsScreen;
